import Zr, { createContext as At, useRef as mr, useMemo as $r, useEffect as jt, useState as Dt, useContext as Qr, useCallback as It } from "react";
import { c as Er, g as Ft, C as Ur, d as Lt } from "./index-5cfde587.js";
var Mr = { exports: {} }, Me = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jr;
function Mt() {
  if (Jr)
    return Me;
  Jr = 1;
  var d = Zr, v = Symbol.for("react.element"), P = Symbol.for("react.fragment"), x = Object.prototype.hasOwnProperty, A = d.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $ = { key: !0, ref: !0, __self: !0, __source: !0 };
  function q(j, _, W) {
    var w, I = {}, H = null, ie = null;
    W !== void 0 && (H = "" + W), _.key !== void 0 && (H = "" + _.key), _.ref !== void 0 && (ie = _.ref);
    for (w in _)
      x.call(_, w) && !$.hasOwnProperty(w) && (I[w] = _[w]);
    if (j && j.defaultProps)
      for (w in _ = j.defaultProps, _)
        I[w] === void 0 && (I[w] = _[w]);
    return { $$typeof: v, type: j, key: H, ref: ie, props: I, _owner: A.current };
  }
  return Me.Fragment = P, Me.jsx = q, Me.jsxs = q, Me;
}
var $e = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xr;
function $t() {
  return Xr || (Xr = 1, process.env.NODE_ENV !== "production" && function() {
    var d = Zr, v = Symbol.for("react.element"), P = Symbol.for("react.portal"), x = Symbol.for("react.fragment"), A = Symbol.for("react.strict_mode"), $ = Symbol.for("react.profiler"), q = Symbol.for("react.provider"), j = Symbol.for("react.context"), _ = Symbol.for("react.forward_ref"), W = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), I = Symbol.for("react.memo"), H = Symbol.for("react.lazy"), ie = Symbol.for("react.offscreen"), Ue = Symbol.iterator, de = "@@iterator";
    function Ne(r) {
      if (r === null || typeof r != "object")
        return null;
      var a = Ue && r[Ue] || r[de];
      return typeof a == "function" ? a : null;
    }
    var X = d.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(r) {
      {
        for (var a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), s = 1; s < a; s++)
          i[s - 1] = arguments[s];
        We("error", r, i);
      }
    }
    function We(r, a, i) {
      {
        var s = X.ReactDebugCurrentFrame, p = s.getStackAddendum();
        p !== "" && (a += "%s", i = i.concat([p]));
        var l = i.map(function(c) {
          return String(c);
        });
        l.unshift("Warning: " + a), Function.prototype.apply.call(console[r], console, l);
      }
    }
    var Rr = !1, Ye = !1, pe = !1, ze = !1, wr = !1, Be;
    Be = Symbol.for("react.module.reference");
    function we(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === x || r === $ || wr || r === A || r === W || r === w || ze || r === ie || Rr || Ye || pe || typeof r == "object" && r !== null && (r.$$typeof === H || r.$$typeof === I || r.$$typeof === q || r.$$typeof === j || r.$$typeof === _ || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Be || r.getModuleId !== void 0));
    }
    function Ge(r, a, i) {
      var s = r.displayName;
      if (s)
        return s;
      var p = a.displayName || a.name || "";
      return p !== "" ? i + "(" + p + ")" : i;
    }
    function oe(r) {
      return r.displayName || "Context";
    }
    function Y(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case x:
          return "Fragment";
        case P:
          return "Portal";
        case $:
          return "Profiler";
        case A:
          return "StrictMode";
        case W:
          return "Suspense";
        case w:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case j:
            var a = r;
            return oe(a) + ".Consumer";
          case q:
            var i = r;
            return oe(i._context) + ".Provider";
          case _:
            return Ge(r, r.render, "ForwardRef");
          case I:
            var s = r.displayName || null;
            return s !== null ? s : Y(r.type) || "Memo";
          case H: {
            var p = r, l = p._payload, c = p._init;
            try {
              return Y(c(l));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var k = Object.assign, se = 0, qe, He, Ke, ke, Ve, Je, Xe;
    function Ze() {
    }
    Ze.__reactDisabledLog = !0;
    function Cr() {
      {
        if (se === 0) {
          qe = console.log, He = console.info, Ke = console.warn, ke = console.error, Ve = console.group, Je = console.groupCollapsed, Xe = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: Ze,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        se++;
      }
    }
    function g() {
      {
        if (se--, se === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: k({}, r, {
              value: qe
            }),
            info: k({}, r, {
              value: He
            }),
            warn: k({}, r, {
              value: Ke
            }),
            error: k({}, r, {
              value: ke
            }),
            group: k({}, r, {
              value: Ve
            }),
            groupCollapsed: k({}, r, {
              value: Je
            }),
            groupEnd: k({}, r, {
              value: Xe
            })
          });
        }
        se < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ve = X.ReactCurrentDispatcher, Ce;
    function F(r, a, i) {
      {
        if (Ce === void 0)
          try {
            throw Error();
          } catch (p) {
            var s = p.stack.trim().match(/\n( *(at )?)/);
            Ce = s && s[1] || "";
          }
        return `
` + Ce + r;
      }
    }
    var ge = !1, ue;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      ue = new Qe();
    }
    function _e(r, a) {
      if (!r || ge)
        return "";
      {
        var i = ue.get(r);
        if (i !== void 0)
          return i;
      }
      var s;
      ge = !0;
      var p = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var l;
      l = ve.current, ve.current = null, Cr();
      try {
        if (a) {
          var c = function() {
            throw Error();
          };
          if (Object.defineProperty(c.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(c, []);
            } catch (B) {
              s = B;
            }
            Reflect.construct(r, [], c);
          } else {
            try {
              c.call();
            } catch (B) {
              s = B;
            }
            r.call(c.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (B) {
            s = B;
          }
          r();
        }
      } catch (B) {
        if (B && s && typeof B.stack == "string") {
          for (var f = B.stack.split(`
`), S = s.stack.split(`
`), y = f.length - 1, m = S.length - 1; y >= 1 && m >= 0 && f[y] !== S[m]; )
            m--;
          for (; y >= 1 && m >= 0; y--, m--)
            if (f[y] !== S[m]) {
              if (y !== 1 || m !== 1)
                do
                  if (y--, m--, m < 0 || f[y] !== S[m]) {
                    var R = `
` + f[y].replace(" at new ", " at ");
                    return r.displayName && R.includes("<anonymous>") && (R = R.replace("<anonymous>", r.displayName)), typeof r == "function" && ue.set(r, R), R;
                  }
                while (y >= 1 && m >= 0);
              break;
            }
        }
      } finally {
        ge = !1, ve.current = l, g(), Error.prepareStackTrace = p;
      }
      var re = r ? r.displayName || r.name : "", pr = re ? F(re) : "";
      return typeof r == "function" && ue.set(r, pr), pr;
    }
    function er(r, a, i) {
      return _e(r, !1);
    }
    function rr(r) {
      var a = r.prototype;
      return !!(a && a.isReactComponent);
    }
    function he(r, a, i) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return _e(r, rr(r));
      if (typeof r == "string")
        return F(r);
      switch (r) {
        case W:
          return F("Suspense");
        case w:
          return F("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case _:
            return er(r.render);
          case I:
            return he(r.type, a, i);
          case H: {
            var s = r, p = s._payload, l = s._init;
            try {
              return he(l(p), a, i);
            } catch {
            }
          }
        }
      return "";
    }
    var ye = Object.prototype.hasOwnProperty, tr = {}, nr = X.ReactDebugCurrentFrame;
    function be(r) {
      if (r) {
        var a = r._owner, i = he(r.type, r._source, a ? a.type : null);
        nr.setExtraStackFrame(i);
      } else
        nr.setExtraStackFrame(null);
    }
    function Sr(r, a, i, s, p) {
      {
        var l = Function.call.bind(ye);
        for (var c in r)
          if (l(r, c)) {
            var f = void 0;
            try {
              if (typeof r[c] != "function") {
                var S = Error((s || "React class") + ": " + i + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw S.name = "Invariant Violation", S;
              }
              f = r[c](a, c, s, i, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (y) {
              f = y;
            }
            f && !(f instanceof Error) && (be(p), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", s || "React class", i, c, typeof f), be(null)), f instanceof Error && !(f.message in tr) && (tr[f.message] = !0, be(p), E("Failed %s type: %s", i, f.message), be(null));
          }
      }
    }
    var Or = Array.isArray;
    function Se(r) {
      return Or(r);
    }
    function Pr(r) {
      {
        var a = typeof Symbol == "function" && Symbol.toStringTag, i = a && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return i;
      }
    }
    function xr(r) {
      try {
        return ar(r), !1;
      } catch {
        return !0;
      }
    }
    function ar(r) {
      return "" + r;
    }
    function ir(r) {
      if (xr(r))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Pr(r)), ar(r);
    }
    var K = X.ReactCurrentOwner, Oe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Pe, L, Ee;
    Ee = {};
    function or(r) {
      if (ye.call(r, "ref")) {
        var a = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (a && a.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function Ar(r) {
      if (ye.call(r, "key")) {
        var a = Object.getOwnPropertyDescriptor(r, "key").get;
        if (a && a.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function sr(r, a) {
      if (typeof r.ref == "string" && K.current && a && K.current.stateNode !== a) {
        var i = Y(K.current.type);
        Ee[i] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Y(K.current.type), r.ref), Ee[i] = !0);
      }
    }
    function me(r, a) {
      {
        var i = function() {
          Pe || (Pe = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
        };
        i.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: i,
          configurable: !0
        });
      }
    }
    function ur(r, a) {
      {
        var i = function() {
          L || (L = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", a));
        };
        i.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: i,
          configurable: !0
        });
      }
    }
    var fr = function(r, a, i, s, p, l, c) {
      var f = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: v,
        // Built-in properties that belong on the element
        type: r,
        key: a,
        ref: i,
        props: c,
        // Record the component responsible for creating this element.
        _owner: l
      };
      return f._store = {}, Object.defineProperty(f._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(f, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: s
      }), Object.defineProperty(f, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: p
      }), Object.freeze && (Object.freeze(f.props), Object.freeze(f)), f;
    };
    function jr(r, a, i, s, p) {
      {
        var l, c = {}, f = null, S = null;
        i !== void 0 && (ir(i), f = "" + i), Ar(a) && (ir(a.key), f = "" + a.key), or(a) && (S = a.ref, sr(a, p));
        for (l in a)
          ye.call(a, l) && !Oe.hasOwnProperty(l) && (c[l] = a[l]);
        if (r && r.defaultProps) {
          var y = r.defaultProps;
          for (l in y)
            c[l] === void 0 && (c[l] = y[l]);
        }
        if (f || S) {
          var m = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          f && me(c, m), S && ur(c, m);
        }
        return fr(r, f, S, p, s, K.current, c);
      }
    }
    var z = X.ReactCurrentOwner, xe = X.ReactDebugCurrentFrame;
    function Z(r) {
      if (r) {
        var a = r._owner, i = he(r.type, r._source, a ? a.type : null);
        xe.setExtraStackFrame(i);
      } else
        xe.setExtraStackFrame(null);
    }
    var Ae;
    Ae = !1;
    function fe(r) {
      return typeof r == "object" && r !== null && r.$$typeof === v;
    }
    function Q() {
      {
        if (z.current) {
          var r = Y(z.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function je(r) {
      {
        if (r !== void 0) {
          var a = r.fileName.replace(/^.*[\\\/]/, ""), i = r.lineNumber;
          return `

Check your code at ` + a + ":" + i + ".";
        }
        return "";
      }
    }
    var Te = {};
    function De(r) {
      {
        var a = Q();
        if (!a) {
          var i = typeof r == "string" ? r : r.displayName || r.name;
          i && (a = `

Check the top-level render call using <` + i + ">.");
        }
        return a;
      }
    }
    function ee(r, a) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var i = De(a);
        if (Te[i])
          return;
        Te[i] = !0;
        var s = "";
        r && r._owner && r._owner !== z.current && (s = " It was passed a child from " + Y(r._owner.type) + "."), Z(r), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', i, s), Z(null);
      }
    }
    function lr(r, a) {
      {
        if (typeof r != "object")
          return;
        if (Se(r))
          for (var i = 0; i < r.length; i++) {
            var s = r[i];
            fe(s) && ee(s, a);
          }
        else if (fe(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var p = Ne(r);
          if (typeof p == "function" && p !== r.entries)
            for (var l = p.call(r), c; !(c = l.next()).done; )
              fe(c.value) && ee(c.value, a);
        }
      }
    }
    function Dr(r) {
      {
        var a = r.type;
        if (a == null || typeof a == "string")
          return;
        var i;
        if (typeof a == "function")
          i = a.propTypes;
        else if (typeof a == "object" && (a.$$typeof === _ || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        a.$$typeof === I))
          i = a.propTypes;
        else
          return;
        if (i) {
          var s = Y(a);
          Sr(i, r.props, "prop", s, r);
        } else if (a.PropTypes !== void 0 && !Ae) {
          Ae = !0;
          var p = Y(a);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", p || "Unknown");
        }
        typeof a.getDefaultProps == "function" && !a.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ir(r) {
      {
        for (var a = Object.keys(r.props), i = 0; i < a.length; i++) {
          var s = a[i];
          if (s !== "children" && s !== "key") {
            Z(r), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", s), Z(null);
            break;
          }
        }
        r.ref !== null && (Z(r), E("Invalid attribute `ref` supplied to `React.Fragment`."), Z(null));
      }
    }
    function cr(r, a, i, s, p, l) {
      {
        var c = we(r);
        if (!c) {
          var f = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (f += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var S = je(p);
          S ? f += S : f += Q();
          var y;
          r === null ? y = "null" : Se(r) ? y = "array" : r !== void 0 && r.$$typeof === v ? (y = "<" + (Y(r.type) || "Unknown") + " />", f = " Did you accidentally export a JSX literal instead of a component?") : y = typeof r, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", y, f);
        }
        var m = jr(r, a, i, p, l);
        if (m == null)
          return m;
        if (c) {
          var R = a.children;
          if (R !== void 0)
            if (s)
              if (Se(R)) {
                for (var re = 0; re < R.length; re++)
                  lr(R[re], r);
                Object.freeze && Object.freeze(R);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              lr(R, r);
        }
        return r === x ? Ir(m) : Dr(m), m;
      }
    }
    function Fr(r, a, i) {
      return cr(r, a, i, !0);
    }
    function dr(r, a, i) {
      return cr(r, a, i, !1);
    }
    var Ie = dr, V = Fr;
    $e.Fragment = x, $e.jsx = Ie, $e.jsxs = V;
  }()), $e;
}
process.env.NODE_ENV === "production" ? Mr.exports = Mt() : Mr.exports = $t();
var Ut = Mr.exports, Tr = { exports: {} };
Tr.exports;
(function(d, v) {
  var P = 200, x = "__lodash_hash_undefined__", A = 1, $ = 2, q = 9007199254740991, j = "[object Arguments]", _ = "[object Array]", W = "[object AsyncFunction]", w = "[object Boolean]", I = "[object Date]", H = "[object Error]", ie = "[object Function]", Ue = "[object GeneratorFunction]", de = "[object Map]", Ne = "[object Number]", X = "[object Null]", E = "[object Object]", We = "[object Promise]", Rr = "[object Proxy]", Ye = "[object RegExp]", pe = "[object Set]", ze = "[object String]", wr = "[object Symbol]", Be = "[object Undefined]", we = "[object WeakMap]", Ge = "[object ArrayBuffer]", oe = "[object DataView]", Y = "[object Float32Array]", k = "[object Float64Array]", se = "[object Int8Array]", qe = "[object Int16Array]", He = "[object Int32Array]", Ke = "[object Uint8Array]", ke = "[object Uint8ClampedArray]", Ve = "[object Uint16Array]", Je = "[object Uint32Array]", Xe = /[\\^$.*+?()[\]{}|]/g, Ze = /^\[object .+?Constructor\]$/, Cr = /^(?:0|[1-9]\d*)$/, g = {};
  g[Y] = g[k] = g[se] = g[qe] = g[He] = g[Ke] = g[ke] = g[Ve] = g[Je] = !0, g[j] = g[_] = g[Ge] = g[w] = g[oe] = g[I] = g[H] = g[ie] = g[de] = g[Ne] = g[E] = g[Ye] = g[pe] = g[ze] = g[we] = !1;
  var ve = typeof Er == "object" && Er && Er.Object === Object && Er, Ce = typeof self == "object" && self && self.Object === Object && self, F = ve || Ce || Function("return this")(), ge = v && !v.nodeType && v, ue = ge && !0 && d && !d.nodeType && d, Qe = ue && ue.exports === ge, _e = Qe && ve.process, er = function() {
    try {
      return _e && _e.binding && _e.binding("util");
    } catch {
    }
  }(), rr = er && er.isTypedArray;
  function he(e, t) {
    for (var n = -1, o = e == null ? 0 : e.length, h = 0, u = []; ++n < o; ) {
      var T = e[n];
      t(T, n, e) && (u[h++] = T);
    }
    return u;
  }
  function ye(e, t) {
    for (var n = -1, o = t.length, h = e.length; ++n < o; )
      e[h + n] = t[n];
    return e;
  }
  function tr(e, t) {
    for (var n = -1, o = e == null ? 0 : e.length; ++n < o; )
      if (t(e[n], n, e))
        return !0;
    return !1;
  }
  function nr(e, t) {
    for (var n = -1, o = Array(e); ++n < e; )
      o[n] = t(n);
    return o;
  }
  function be(e) {
    return function(t) {
      return e(t);
    };
  }
  function Sr(e, t) {
    return e.has(t);
  }
  function Or(e, t) {
    return e == null ? void 0 : e[t];
  }
  function Se(e) {
    var t = -1, n = Array(e.size);
    return e.forEach(function(o, h) {
      n[++t] = [h, o];
    }), n;
  }
  function Pr(e, t) {
    return function(n) {
      return e(t(n));
    };
  }
  function xr(e) {
    var t = -1, n = Array(e.size);
    return e.forEach(function(o) {
      n[++t] = o;
    }), n;
  }
  var ar = Array.prototype, ir = Function.prototype, K = Object.prototype, Oe = F["__core-js_shared__"], Pe = ir.toString, L = K.hasOwnProperty, Ee = function() {
    var e = /[^.]+$/.exec(Oe && Oe.keys && Oe.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }(), or = K.toString, Ar = RegExp(
    "^" + Pe.call(L).replace(Xe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), sr = Qe ? F.Buffer : void 0, me = F.Symbol, ur = F.Uint8Array, fr = K.propertyIsEnumerable, jr = ar.splice, z = me ? me.toStringTag : void 0, xe = Object.getOwnPropertySymbols, Z = sr ? sr.isBuffer : void 0, Ae = Pr(Object.keys, Object), fe = Re(F, "DataView"), Q = Re(F, "Map"), je = Re(F, "Promise"), Te = Re(F, "Set"), De = Re(F, "WeakMap"), ee = Re(Object, "create"), lr = le(fe), Dr = le(Q), Ir = le(je), cr = le(Te), Fr = le(De), dr = me ? me.prototype : void 0, Ie = dr ? dr.valueOf : void 0;
  function V(e) {
    var t = -1, n = e == null ? 0 : e.length;
    for (this.clear(); ++t < n; ) {
      var o = e[t];
      this.set(o[0], o[1]);
    }
  }
  function r() {
    this.__data__ = ee ? ee(null) : {}, this.size = 0;
  }
  function a(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }
  function i(e) {
    var t = this.__data__;
    if (ee) {
      var n = t[e];
      return n === x ? void 0 : n;
    }
    return L.call(t, e) ? t[e] : void 0;
  }
  function s(e) {
    var t = this.__data__;
    return ee ? t[e] !== void 0 : L.call(t, e);
  }
  function p(e, t) {
    var n = this.__data__;
    return this.size += this.has(e) ? 0 : 1, n[e] = ee && t === void 0 ? x : t, this;
  }
  V.prototype.clear = r, V.prototype.delete = a, V.prototype.get = i, V.prototype.has = s, V.prototype.set = p;
  function l(e) {
    var t = -1, n = e == null ? 0 : e.length;
    for (this.clear(); ++t < n; ) {
      var o = e[t];
      this.set(o[0], o[1]);
    }
  }
  function c() {
    this.__data__ = [], this.size = 0;
  }
  function f(e) {
    var t = this.__data__, n = gr(t, e);
    if (n < 0)
      return !1;
    var o = t.length - 1;
    return n == o ? t.pop() : jr.call(t, n, 1), --this.size, !0;
  }
  function S(e) {
    var t = this.__data__, n = gr(t, e);
    return n < 0 ? void 0 : t[n][1];
  }
  function y(e) {
    return gr(this.__data__, e) > -1;
  }
  function m(e, t) {
    var n = this.__data__, o = gr(n, e);
    return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
  }
  l.prototype.clear = c, l.prototype.delete = f, l.prototype.get = S, l.prototype.has = y, l.prototype.set = m;
  function R(e) {
    var t = -1, n = e == null ? 0 : e.length;
    for (this.clear(); ++t < n; ) {
      var o = e[t];
      this.set(o[0], o[1]);
    }
  }
  function re() {
    this.size = 0, this.__data__ = {
      hash: new V(),
      map: new (Q || l)(),
      string: new V()
    };
  }
  function pr(e) {
    var t = _r(this, e).delete(e);
    return this.size -= t ? 1 : 0, t;
  }
  function B(e) {
    return _r(this, e).get(e);
  }
  function et(e) {
    return _r(this, e).has(e);
  }
  function rt(e, t) {
    var n = _r(this, e), o = n.size;
    return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
  }
  R.prototype.clear = re, R.prototype.delete = pr, R.prototype.get = B, R.prototype.has = et, R.prototype.set = rt;
  function vr(e) {
    var t = -1, n = e == null ? 0 : e.length;
    for (this.__data__ = new R(); ++t < n; )
      this.add(e[t]);
  }
  function tt(e) {
    return this.__data__.set(e, x), this;
  }
  function nt(e) {
    return this.__data__.has(e);
  }
  vr.prototype.add = vr.prototype.push = tt, vr.prototype.has = nt;
  function te(e) {
    var t = this.__data__ = new l(e);
    this.size = t.size;
  }
  function at() {
    this.__data__ = new l(), this.size = 0;
  }
  function it(e) {
    var t = this.__data__, n = t.delete(e);
    return this.size = t.size, n;
  }
  function ot(e) {
    return this.__data__.get(e);
  }
  function st(e) {
    return this.__data__.has(e);
  }
  function ut(e, t) {
    var n = this.__data__;
    if (n instanceof l) {
      var o = n.__data__;
      if (!Q || o.length < P - 1)
        return o.push([e, t]), this.size = ++n.size, this;
      n = this.__data__ = new R(o);
    }
    return n.set(e, t), this.size = n.size, this;
  }
  te.prototype.clear = at, te.prototype.delete = it, te.prototype.get = ot, te.prototype.has = st, te.prototype.set = ut;
  function ft(e, t) {
    var n = hr(e), o = !n && wt(e), h = !n && !o && Lr(e), u = !n && !o && !h && kr(e), T = n || o || h || u, C = T ? nr(e.length, String) : [], O = C.length;
    for (var b in e)
      (t || L.call(e, b)) && !(T && // Safari 9 has enumerable `arguments.length` in strict mode.
      (b == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (b == "offset" || b == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      u && (b == "buffer" || b == "byteLength" || b == "byteOffset") || // Skip index properties.
      bt(b, O))) && C.push(b);
    return C;
  }
  function gr(e, t) {
    for (var n = e.length; n--; )
      if (Gr(e[n][0], t))
        return n;
    return -1;
  }
  function lt(e, t, n) {
    var o = t(e);
    return hr(e) ? o : ye(o, n(e));
  }
  function Fe(e) {
    return e == null ? e === void 0 ? Be : X : z && z in Object(e) ? ht(e) : Rt(e);
  }
  function Wr(e) {
    return Le(e) && Fe(e) == j;
  }
  function Yr(e, t, n, o, h) {
    return e === t ? !0 : e == null || t == null || !Le(e) && !Le(t) ? e !== e && t !== t : ct(e, t, n, o, Yr, h);
  }
  function ct(e, t, n, o, h, u) {
    var T = hr(e), C = hr(t), O = T ? _ : ne(e), b = C ? _ : ne(t);
    O = O == j ? E : O, b = b == j ? E : b;
    var M = O == E, G = b == E, D = O == b;
    if (D && Lr(e)) {
      if (!Lr(t))
        return !1;
      T = !0, M = !1;
    }
    if (D && !M)
      return u || (u = new te()), T || kr(e) ? zr(e, t, n, o, h, u) : gt(e, t, O, n, o, h, u);
    if (!(n & A)) {
      var U = M && L.call(e, "__wrapped__"), N = G && L.call(t, "__wrapped__");
      if (U || N) {
        var ae = U ? e.value() : e, J = N ? t.value() : t;
        return u || (u = new te()), h(ae, J, n, o, u);
      }
    }
    return D ? (u || (u = new te()), _t(e, t, n, o, h, u)) : !1;
  }
  function dt(e) {
    if (!Kr(e) || mt(e))
      return !1;
    var t = qr(e) ? Ar : Ze;
    return t.test(le(e));
  }
  function pt(e) {
    return Le(e) && Hr(e.length) && !!g[Fe(e)];
  }
  function vt(e) {
    if (!Tt(e))
      return Ae(e);
    var t = [];
    for (var n in Object(e))
      L.call(e, n) && n != "constructor" && t.push(n);
    return t;
  }
  function zr(e, t, n, o, h, u) {
    var T = n & A, C = e.length, O = t.length;
    if (C != O && !(T && O > C))
      return !1;
    var b = u.get(e);
    if (b && u.get(t))
      return b == t;
    var M = -1, G = !0, D = n & $ ? new vr() : void 0;
    for (u.set(e, t), u.set(t, e); ++M < C; ) {
      var U = e[M], N = t[M];
      if (o)
        var ae = T ? o(N, U, M, t, e, u) : o(U, N, M, e, t, u);
      if (ae !== void 0) {
        if (ae)
          continue;
        G = !1;
        break;
      }
      if (D) {
        if (!tr(t, function(J, ce) {
          if (!Sr(D, ce) && (U === J || h(U, J, n, o, u)))
            return D.push(ce);
        })) {
          G = !1;
          break;
        }
      } else if (!(U === N || h(U, N, n, o, u))) {
        G = !1;
        break;
      }
    }
    return u.delete(e), u.delete(t), G;
  }
  function gt(e, t, n, o, h, u, T) {
    switch (n) {
      case oe:
        if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
          return !1;
        e = e.buffer, t = t.buffer;
      case Ge:
        return !(e.byteLength != t.byteLength || !u(new ur(e), new ur(t)));
      case w:
      case I:
      case Ne:
        return Gr(+e, +t);
      case H:
        return e.name == t.name && e.message == t.message;
      case Ye:
      case ze:
        return e == t + "";
      case de:
        var C = Se;
      case pe:
        var O = o & A;
        if (C || (C = xr), e.size != t.size && !O)
          return !1;
        var b = T.get(e);
        if (b)
          return b == t;
        o |= $, T.set(e, t);
        var M = zr(C(e), C(t), o, h, u, T);
        return T.delete(e), M;
      case wr:
        if (Ie)
          return Ie.call(e) == Ie.call(t);
    }
    return !1;
  }
  function _t(e, t, n, o, h, u) {
    var T = n & A, C = Br(e), O = C.length, b = Br(t), M = b.length;
    if (O != M && !T)
      return !1;
    for (var G = O; G--; ) {
      var D = C[G];
      if (!(T ? D in t : L.call(t, D)))
        return !1;
    }
    var U = u.get(e);
    if (U && u.get(t))
      return U == t;
    var N = !0;
    u.set(e, t), u.set(t, e);
    for (var ae = T; ++G < O; ) {
      D = C[G];
      var J = e[D], ce = t[D];
      if (o)
        var Vr = T ? o(ce, J, D, t, e, u) : o(J, ce, D, e, t, u);
      if (!(Vr === void 0 ? J === ce || h(J, ce, n, o, u) : Vr)) {
        N = !1;
        break;
      }
      ae || (ae = D == "constructor");
    }
    if (N && !ae) {
      var yr = e.constructor, br = t.constructor;
      yr != br && "constructor" in e && "constructor" in t && !(typeof yr == "function" && yr instanceof yr && typeof br == "function" && br instanceof br) && (N = !1);
    }
    return u.delete(e), u.delete(t), N;
  }
  function Br(e) {
    return lt(e, Ot, yt);
  }
  function _r(e, t) {
    var n = e.__data__;
    return Et(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
  }
  function Re(e, t) {
    var n = Or(e, t);
    return dt(n) ? n : void 0;
  }
  function ht(e) {
    var t = L.call(e, z), n = e[z];
    try {
      e[z] = void 0;
      var o = !0;
    } catch {
    }
    var h = or.call(e);
    return o && (t ? e[z] = n : delete e[z]), h;
  }
  var yt = xe ? function(e) {
    return e == null ? [] : (e = Object(e), he(xe(e), function(t) {
      return fr.call(e, t);
    }));
  } : Pt, ne = Fe;
  (fe && ne(new fe(new ArrayBuffer(1))) != oe || Q && ne(new Q()) != de || je && ne(je.resolve()) != We || Te && ne(new Te()) != pe || De && ne(new De()) != we) && (ne = function(e) {
    var t = Fe(e), n = t == E ? e.constructor : void 0, o = n ? le(n) : "";
    if (o)
      switch (o) {
        case lr:
          return oe;
        case Dr:
          return de;
        case Ir:
          return We;
        case cr:
          return pe;
        case Fr:
          return we;
      }
    return t;
  });
  function bt(e, t) {
    return t = t ?? q, !!t && (typeof e == "number" || Cr.test(e)) && e > -1 && e % 1 == 0 && e < t;
  }
  function Et(e) {
    var t = typeof e;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
  }
  function mt(e) {
    return !!Ee && Ee in e;
  }
  function Tt(e) {
    var t = e && e.constructor, n = typeof t == "function" && t.prototype || K;
    return e === n;
  }
  function Rt(e) {
    return or.call(e);
  }
  function le(e) {
    if (e != null) {
      try {
        return Pe.call(e);
      } catch {
      }
      try {
        return e + "";
      } catch {
      }
    }
    return "";
  }
  function Gr(e, t) {
    return e === t || e !== e && t !== t;
  }
  var wt = Wr(function() {
    return arguments;
  }()) ? Wr : function(e) {
    return Le(e) && L.call(e, "callee") && !fr.call(e, "callee");
  }, hr = Array.isArray;
  function Ct(e) {
    return e != null && Hr(e.length) && !qr(e);
  }
  var Lr = Z || xt;
  function St(e, t) {
    return Yr(e, t);
  }
  function qr(e) {
    if (!Kr(e))
      return !1;
    var t = Fe(e);
    return t == ie || t == Ue || t == W || t == Rr;
  }
  function Hr(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= q;
  }
  function Kr(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  function Le(e) {
    return e != null && typeof e == "object";
  }
  var kr = rr ? be(rr) : pt;
  function Ot(e) {
    return Ct(e) ? ft(e) : vt(e);
  }
  function Pt() {
    return [];
  }
  function xt() {
    return !1;
  }
  d.exports = St;
})(Tr, Tr.exports);
var Nt = Tr.exports;
const Wt = /* @__PURE__ */ Ft(Nt);
function Yt(d) {
  const v = mr(d), P = mr(0);
  return Wt(d, v.current) || (v.current = d, P.current += 1), $r(() => v.current, [P.current]);
}
function zt(d, v) {
  return jt(d, Yt(v));
}
const Nr = At(null);
function qt({
  children: d,
  locale: v,
  debugMode: P = !1,
  enableInspectorMode: x = !0,
  enableLiveUpdates: A = !0
}) {
  if (!v)
    throw new Error(
      'ContentfulLivePreviewProvider have to be called with a locale property (for example: `<ContentfulLivePreviewProvider locale="en-US">{children}</ContentfulLivePreviewProvider>`'
    );
  Ur.init({ locale: v, debugMode: P, enableInspectorMode: x, enableLiveUpdates: A });
  const $ = $r(
    () => ({ locale: v, debugMode: P, enableInspectorMode: x, enableLiveUpdates: A }),
    [v, P, x, A]
  );
  return /* @__PURE__ */ Ut.jsx(Nr.Provider, { value: $, children: d });
}
function Ht(d, v, P = !1) {
  const [x, A] = Dt({ data: d, version: 1 }), $ = mr(d), q = mr(Lt(A)), j = Qr(Nr), _ = typeof v == "object" ? v : { locale: v, skip: P }, W = $r(() => j && !j.enableLiveUpdates || _.skip ? !1 : !!(Array.isArray(d) && d.length || d && typeof d == "object" && Object.keys(d).length), [j, _.skip, d]);
  return zt(() => {
    if ($.current !== d && (A({ data: d, version: 1 }), $.current = d), !!W)
      return Ur.subscribe({
        data: d,
        locale: _.locale,
        query: _.query,
        callback: (w) => {
          q.current((I) => ({ data: w, version: I.version + 1 }));
        }
      });
  }, [d, W, _.locale, _.query]), x.data;
}
function Kt(d) {
  const v = Qr(Nr);
  return It(
    (P) => v != null && v.enableInspectorMode ? Ur.getProps({ ...d, ...P }) : null,
    [v == null ? void 0 : v.enableInspectorMode, d]
  );
}
export {
  qt as ContentfulLivePreviewProvider,
  Kt as useContentfulInspectorMode,
  Ht as useContentfulLiveUpdates,
  zt as useDeepCompareEffectNoCheck,
  Yt as useDeepCompareMemoize
};
//# sourceMappingURL=react.js.map
